import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { UserPlus, Settings, Truck } from 'lucide-react';

export const HowItWorksSection = () => {
  const steps = [
    {
      icon: UserPlus,
      title: "Sign Up",
      description: "Quick carrier packet + dispatcher agreement to get you started.",
      step: "01"
    },
    {
      icon: Settings,
      title: "Set Your Preferences",
      description: "Lanes, equipment, min rate, home time—tell us exactly what you need.",
      step: "02"
    },
    {
      icon: Truck,
      title: "Roll Out",
      description: "We find, book, and confirm loads—then keep you moving profitably.",
      step: "03"
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">How It Works</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Getting started is simple. We handle the complex stuff so you can focus on driving.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-orange-200 transform translate-x-4 z-0"></div>
              )}
              <Card className="relative z-10 hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-orange-200">
                <CardHeader className="text-center pb-4">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-100 to-orange-200 rounded-full flex items-center justify-center mx-auto mb-4 relative">
                    <step.icon className="h-10 w-10 text-orange-600" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                      {step.step}
                    </div>
                  </div>
                  <CardTitle className="text-2xl font-bold text-gray-900">{step.title}</CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <p className="text-gray-600 leading-relaxed text-lg">{step.description}</p>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};